import { render } from "./CallCenterPage.vue?vue&type=template&id=17186acb&ts=true"
import script from "./CallCenterPage.vue?vue&type=script&lang=ts"
export * from "./CallCenterPage.vue?vue&type=script&lang=ts"

import "./CallCenterPage.vue?vue&type=style&index=0&id=17186acb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__